import archiveSaga from './components/Actions/ArchiveSaga';

export default [archiveSaga];